module.exports = __webpack_public_path__ + "img/business.af1934c7.webp";